import type { AttendeeView } from '@/lib/recordings/types/attendees';

/**
 * Resolve the best display name for an attendee row.
 *
 * Order:
 *   1. Apollo `name` (only when `enrichmentStatus === 'enriched'`).
 *   2. Calendar invite `displayName`.
 *   3. The email itself.
 *
 * Whitespace-only strings count as missing.
 */
export function displayNameFor(attendee: AttendeeView): string {
  if (attendee.enrichmentStatus === 'enriched') {
    const name = attendee.name?.trim();
    if (name) return name;
  }
  const displayName = attendee.displayName?.trim();
  if (displayName) return displayName;
  return attendee.email;
}
